// extracted by mini-css-extract-plugin
export default {"headerContainer":"MobileHeader_headerContainer__1hAGy","title":"MobileHeader_title__62vjV"};